import axios from "axios";
import { URL_BASE } from "../0_url_base";

//const URL = 'http://localhost:3001/filiado/emplacar';
//const URL = 'https://conexaodetranpr.sindilocpr.com.br/api/filiado/emplacar';
const URL = URL_BASE + '/admin/emplacar';

const AdminEmplacarAPI = axios.create({
    baseURL: URL,
    headers: {
        Accept: 'application/json',
        Content: 'application/json'
    }
})

AdminEmplacarAPI.interceptors.request.use(function (config) {
    const Token = sessionStorage.getItem('token');
    if((Token) && (config.headers)){
        config.headers.Authorization = `Bearer ${Token}`
    }
    return config;
}, function (error) {
    console.log("Erro na API de Administrar o Emplacamento ");
    return Promise.reject(error);
});


AdminEmplacarAPI.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return Promise.reject(error);
});


export {
    AdminEmplacarAPI
};